import React from 'react';
import StaticPageTemplate from '../components/ui/StaticPageTemplate';
import styled from 'styled-components';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { linksPageQuery } from '../queries';

const LinksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
`;

const LinkCard = styled.a`
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
  border-radius: 8px;
  padding: 1.5rem;
  text-decoration: none;
  color: #333;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

const LinkTitle = styled.h3`
  color: #2E5984;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  
  svg {
    margin-left: 0.5rem;
    font-size: 0.8rem;
  }
`;

const LinkDescription = styled.p`
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.5rem;
`;

const LinkURL = styled.span`
  color: #4A90E2;
  font-size: 0.8rem;
  margin-top: auto;
`;

const Links = () => {
  const defaultData = {
    title: "Links",
    subtitle: "Useful resources and information",
    introText: "The following links may provide useful information for prospective residents or clients, families, staff etc.",
    links: []
  };

  const customContent = (pageData) => (
    <LinksGrid>
      {pageData && pageData.links && pageData.links.map((link, index) => (
        <LinkCard key={index} href={link.linkUrl} target="_blank" rel="noopener noreferrer">
          <LinkTitle>
            {link.linkTitle} <FaExternalLinkAlt />
          </LinkTitle>
          <LinkDescription>
            {link.linkDescription}
          </LinkDescription>
          <LinkURL>{link.displayUrl}</LinkURL>
        </LinkCard>
      ))}
    </LinksGrid>
  );

  return (
    <StaticPageTemplate
      pageName="linksPage"
      query={linksPageQuery}
      defaultData={defaultData}
      customContent={customContent}
    />
  );
};

export default Links;
